import { render, staticRenderFns } from "./wizardTraineeRegistration.vue?vue&type=template&id=15584e70&scoped=true"
import script from "./wizardTraineeRegistration.vue?vue&type=script&lang=js"
export * from "./wizardTraineeRegistration.vue?vue&type=script&lang=js"
import style0 from "./wizardTraineeRegistration.vue?vue&type=style&index=0&id=15584e70&prod&scoped=true&lang=css"
import style1 from "./wizardTraineeRegistration.vue?vue&type=style&index=1&id=15584e70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15584e70",
  null
  
)

export default component.exports